(function () {
  'use strict';

  function create(root, options) {
    var cart = window.JRJ_TUNE_CART;
    var settings = options || {};
    var camInput = settings.camInput;
    var panel = root && root.querySelector('[data-jrj-custom-cam-specs]');
    if (!cart || !root || !camInput || !panel) return null;

    var inputs = {};
    Array.prototype.slice.call(panel.querySelectorAll('[data-jrj-cam-spec]')).forEach(function (input) {
      inputs[input.getAttribute('data-jrj-cam-spec')] = input;
    });
    var requiredNames = ['intakeDuration', 'exhaustDuration', 'lsa'];
    var result = panel.querySelector('[data-jrj-cam-tier-result]');
    var tier = panel.querySelector('[data-jrj-cam-tier]');
    var price = panel.querySelector('[data-jrj-cam-price]');
    var score = panel.querySelector('[data-jrj-cam-score]');
    var priceToken = 0;
    var snapshot = null;

    function readSpecs() {
      var specs = {};
      Object.keys(inputs).forEach(function (name) { specs[name] = String(inputs[name].value || '').trim(); });
      return specs;
    }

    function priceText(cents) {
      var formatted = cart.formatPrice(cents);
      return formatted ? '+' + formatted : 'Price unavailable';
    }

    function refresh(notify) {
      var selected = cart.isCustomCamSelection(camInput.value);
      panel.hidden = !selected;
      Object.keys(inputs).forEach(function (name) {
        inputs[name].disabled = !selected;
        inputs[name].required = selected && requiredNames.indexOf(name) !== -1;
        inputs[name].setAttribute('aria-required', String(selected && requiredNames.indexOf(name) !== -1));
      });

      var specs = readSpecs();
      var calculation = selected ? cart.calculateCamTier(specs) : null;
      var canonicalCam = calculation ? cart.buildCamSelectionLabel(camInput.value, specs) : String(camInput.value || '').trim();
      snapshot = {
        selected: selected,
        valid: !selected || !!calculation,
        specs: specs,
        calculation: calculation,
        canonicalCam: canonicalCam
      };

      if (result) result.hidden = !calculation;
      if (calculation) {
        if (tier) tier.textContent = calculation.tier;
        if (score) {
          score.textContent = 'Average duration ' + calculation.averageDuration.toFixed(2) + '; overlap at .050 ' + calculation.overlap.toFixed(2) + '; cam size score ' + calculation.score.toFixed(2) + '.';
        }

        var upgrade = typeof settings.resolveUpgrade === 'function'
          ? settings.resolveUpgrade(canonicalCam, calculation)
          : null;
        var currentToken = ++priceToken;
        if (calculation.tierNumber === 1) {
          if (price) price.textContent = '+$0.00';
        } else if (!upgrade) {
          if (price) price.textContent = 'Price unavailable';
        } else {
          var fallbackCents = Number(upgrade.priceCents) || 0;
          if (price) price.textContent = fallbackCents ? priceText(fallbackCents) : 'Loading live price...';
          if (upgrade.variantId || upgrade.handle) {
            cart.resolvePricedItem(upgrade, typeof settings.engineHint === 'function' ? settings.engineHint() : '')
              .then(function (resolved) {
                if (currentToken !== priceToken || !price || !resolved) return;
                price.textContent = priceText(Number(resolved.priceCents) || fallbackCents);
              })
              .catch(function () {
                if (currentToken !== priceToken || !price) return;
                price.textContent = fallbackCents ? priceText(fallbackCents) : 'Price unavailable';
              });
          }
        }
      } else {
        priceToken += 1;
      }

      if (notify !== false && typeof settings.onChange === 'function') settings.onChange(snapshot);
      return snapshot;
    }

    Object.keys(inputs).forEach(function (name) {
      inputs[name].addEventListener('input', function () { refresh(true); });
      inputs[name].addEventListener('change', function () { refresh(true); });
    });

    refresh(false);
    return {
      refresh: refresh,
      getSnapshot: function () { return snapshot || refresh(false); },
      isComplete: function () { return !!(snapshot || refresh(false)).valid; },
      canonicalCam: function () { return (snapshot || refresh(false)).canonicalCam; }
    };
  }

  window.JRJ_CUSTOM_CAM_SPECS = { create: create };
})();
